/**
 * USC Cabinet API
 * Cabinet API
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type LoginType = 'EskNumber' | 'PhoneNumber' | 'Snils';

export const LoginType = {
  EskNumber: 'EskNumber' as LoginType,
  PhoneNumber: 'PhoneNumber' as LoginType,
  Snils: 'Snils' as LoginType,
};
